import { HelpIcon } from '@THC/components/Icons/Help';
import { MDText } from 'i18n-react';

import { IconTooltip } from 'Components/shared/IconTooltip';
import { triggerDeliveryCostTooltipHoverEvent } from 'Services/analytics/events';
import { applySessionReplayActionName, applySessionReplayMask } from 'Services/datadog/datadogRum';
import { MASKED_EVENT_VALUES } from 'Services/datadog/datadogRum.const';
import type { TransportValue } from 'Types/transportOptions';

import type { UseTransportAndTransportOptionsResponse } from '../../../transport/useTransportAndTransportOptions.types';
import LocalTexts from '../DeliveryLocation/DeliveryLocation.texts';

import styles from './DeliveryLocationFieldValue.module.scss';

const { delivery: ddDeliveryValues } = MASKED_EVENT_VALUES;

const privacyParams = {
	deliveryPriceTooltip: applySessionReplayActionName(ddDeliveryValues.price.tooltip),
	deliveryPriceValue: applySessionReplayMask({ maskedActionName: ddDeliveryValues.price.value }),
};

const LocalT = new MDText(LocalTexts);

type DeliveryLocationFieldValueProps = {
	delivery: {
		content: string;
		drivingDistance?: Nullable<number>;
		requiresFerry: UseTransportAndTransportOptionsResponse['transportOptions']['requiresFerry'];
		transportValue: TransportValue;
	};
};

export const DeliveryLocationFieldValue: React.FC<DeliveryLocationFieldValueProps> = ({ delivery }) => {
	const {
		content,
		drivingDistance,
		requiresFerry,
		transportValue: { price },
	} = delivery;

	const appendWithDrivingDistance = drivingDistance
		? LocalT.translate('tooltipContent.drivingDistance', { drivingDistance: Math.round(drivingDistance) })
		: '';

	const shouldShowPrice = Boolean(price && !requiresFerry);

	return (
		<div className={styles.info}>
			<div className={styles.price} {...privacyParams.deliveryPriceValue}>
				{shouldShowPrice ? (
					<>
						<span>{LocalT.translate('delivery.cost', { price })}</span>
						<span className={styles.priceEstimateSuffix}>{LocalT.translate('delivery.plusVat')}</span>
					</>
				) : (
					LocalT.translate('delivery.notApplicable')
				)}
			</div>
			{Boolean(price) && (
				<div className={styles.tooltip} {...privacyParams.deliveryPriceTooltip}>
					<IconTooltip
						content={LocalT.translate(content, { appendWithDrivingDistance })}
						icon={() => <HelpIcon filled={false} />}
						onMouseEnter={triggerDeliveryCostTooltipHoverEvent}
						side="bottom"
					/>
				</div>
			)}
		</div>
	);
};
